import { isEqual, result } from 'lodash'
import { mapGetters, mapState } from 'vuex'

export default
{
	computed:
	{
		...mapState
		({
			account: state => state.accounts.account,
		}),

		...mapGetters
		([
			'hasAccount',
		]),

		canPayInvoice()
		{
			return result(this.account, 'can_pay_online')

			const billToCountry = result(this.account, 'bill_to.country')
			const isParent      = result(this.account, 'is_parent')

			return isParent && isEqual('US', billToCountry)
		},
	},
}